export const GET_TODOS_FOLDER = 'GET_TODOS_FOLDER'
export const GET_TODOS_FOLDER_STRUCTURE = 'GET_TODOS_FOLDER_STRUCTURE'
